<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8iBP8a/tc-custom/9781466800496.jpg?1728155781804" alt="This image is the cover for the book Cliffs of Fall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cliffs of Fall
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of <i>The Great Fire</i>, a collection of stories about love and acceptance, expectations and disappointment</b><br/><br/>Shirley Hazzard's stories are sharp, sensitive portrayals of moments of crisis. Whether they are set in the Italian countryside or suburban Connecticut, the stories deal with real people and real problems.<br/><br/>In the title piece, a young widow is surprised and ashamed by her lack of grief for her husband.<br/>In "A Place in the Country," a young woman has a passionate, guilty affair with her cousin's husband. In "Harold," a gawky, lonely young man finds acceptance and respect through his poetry. <br/><br/>Moving and evocative, these ten stories are written with subtlety, humor, and a keen understanding of the relationships between men and women.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shirley Hazzard
      </h2>
      
      <p class="authorDescription body article"><B>Shirley Hazzard </B>(1931-2016)  is the author, most recently, of<I> Greene on Capri</I>, a memoir of Graham Greene, and several works of fiction, including <I>The Evening of the Holiday</I>, <I>The Bay of Noon, </I>and <I>The Transit of Venus</I>, winner of the 1981 National Book Critics Circle Award. She lived in New York City and Capri.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42af7ed4